var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow-y":"hidden","overflow-x":"hidden"},attrs:{"id":"app"}},[_c('transition',{attrs:{"name":_vm.switchTransition}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }